import React from "react";

const Dashboard = React.lazy(() => import("./views/dashboard/Dashboard"));

const dashboardPartner = React.lazy(() =>
  import("./views/dashboard/DashboardPartner")
);

const paymentReceived = React.lazy(() =>
  import("./views/payment/PaymentRecieved")
);

const paymentSettlement = React.lazy(() =>
  import("./views/payment/PaymentSettlement")
);
const baasTopUps = React.lazy(() => import("./views/baas/TopUps"));
const baasAccount = React.lazy(() => import("./views/baas/BaasAccounts"));
const baasAccountWithdrawal = React.lazy(() =>
  import("./views/baas/BaasAccountWithdrawal")
);

const paymentRefund = React.lazy(() => import("./views/payment/PaymentRefund"));

const customerList = React.lazy(() => import("./views/customer/AllCustomers"));

const newCustomer = React.lazy(() => import("./views/customer/NewCustomers"));
const suspendedCustomer = React.lazy(() =>
  import("./views/customer/SuspendedCustomers")
);

const report = React.lazy(() => import("./views/balances/Report"));

const invoices = React.lazy(() => import("./views/balances/Invoices"));

const messageOutbox = React.lazy(() => import("./views/message/MessageOutbox"));
const messageBaasOutbox = React.lazy(() =>
  import("./views/message/MessageBaasOutbox")
);

const messageInbox = React.lazy(() => import("./views/message/MessageInbox"));

const orgProviderAccount = React.lazy(() =>
  import("./views/settings/orgProviderAccount")
);

const orgAccount = React.lazy(() => import("./views/settings/orgAccount"));

const orgAccountPreference = React.lazy(() =>
  import("./views/settings/orgAccountPreference")
);

const loanActive = React.lazy(() => import("./views/loans/LoanActive"));

const loanOverdue = React.lazy(() => import("./views/loans/LoanOverdue"));

const loanSettled = React.lazy(() => import("./views/loans/LoanSettled"));

const loanRequests = React.lazy(() => import("./views/loans/LoanRequests"));

const loanView = React.lazy(() => import("./views/loans/LoanView"));

const goalActive = React.lazy(() => import("./views/goals/GoalActive"));
const goalOverdue = React.lazy(() => import("./views/goals/GoalOverdue"));
const goalInActive = React.lazy(() => import("./views/goals/GoalInactive"));
const goalCompleteActive = React.lazy(() =>
  import("./views/goals/GoalComplete")
);

const allCorporates = React.lazy(() =>
  import("./views/corporate/AllCorporates")
);

const newClient = React.lazy(() => import("./views/customer/AddCustomers"));
const addCorporate = React.lazy(() => import("./views/corporate/AddCorporate"));
const employeeList = React.lazy(() => import("./views/corporate/EmployeeList"));
const clientBlocked = React.lazy(() =>
  import("./views/corporate/ClientBlocked")
);
const adminInvoices = React.lazy(() =>
  import("./views/corporate/AdminInvoices")
);
const adminInvoiceSettlement = React.lazy(() =>
  import("./views/corporate/AdminInvoiceSettlement")
);
const loanRequestPartner = React.lazy(() =>
  import("./views/partner-loans/LoanRequests")
);

const loanUpaidPartner = React.lazy(() =>
  import("./views/partner-loans/LoanOverdue")
);

const loanActivePartner = React.lazy(() =>
  import("./views/partner-loans/LoanActive")
);

const loanIssueFrom = React.lazy(() =>
  import("./views/partner-loans/LoanIssueFrom")
);

const loanPaidUpPartner = React.lazy(() =>
  import("./views/partner-loans/LoanSettled")
);
const invoicePartner = React.lazy(() =>
  import("./views/partner-payment/Invoices")
);

const invoiceSettlement = React.lazy(() =>
  import("./views/partner-payment/InvoiceSettlement")
);

const baasDisbursement = React.lazy(() =>
  import("./views/partner-payment/BaasDisbursement")
);

const baasPaymentRefund = React.lazy(() =>
  import("./views/partner-payment/BaasPaymentRefund")
);

const baasPaymentRecieved = React.lazy(() =>
  import("./views/partner-payment/BaasPaymentRecieved")
);
const topUp = React.lazy(() => import("./views/partner-payment/TopUp"));

const baasAccountStatement = React.lazy(() =>
  import("./views/partner-payment/BaasAccountStatement")
);
const baasIntiatedTransfer = React.lazy(() =>
  import("./views/partner-payment/BaasIntiatedTransfer")
);
const baasWithdrawal = React.lazy(() =>
  import("./views/partner-payment/BaasWithdrawal")
);

const corporateUsers = React.lazy(() => import("./views/partner-users/Users"));

const orgProviderPaymentMethod = React.lazy(() =>
  import("./views/settings/orgProviderPaymentMethod")
);
const orgConfirmationStatus = React.lazy(() =>
  import("./views/settings/orgConfirmationStatus")
);
const customerView = React.lazy(() => import("./views/customer/CustomerView"));
const corporateView = React.lazy(() =>
  import("./views/corporate/CorporateView")
);
const users = React.lazy(() => import("./views/users/Users"));
const roles = React.lazy(() => import("./views/users/Roles"));
const permission = React.lazy(() => import("./views/users/Permission"));

const addUser = React.lazy(() => import("./views/users/AddUser"));

const editUser = React.lazy(() => import("./views/users/EditUser"));
const accountManger = React.lazy(() =>
  import("./views/corporate/AccountManager")
);

const accountMangerView = React.lazy(() =>
  import("./views/corporate/AccountMangerView")
);

const wageIncomeRecieved = React.lazy(() =>
  import("./views/reports/WageIncomeRecieved")
);

const WageAgeingReport = React.lazy(() =>
  import("./views/reports/WageAgeingReport")
);
const routes = [
  { path: "/", exact: true, name: "Home" },
  { path: "/dashboard", name: "Dashboard", component: Dashboard },
  {
    path: "/loan/active",
    name: "Active Advance",
    component: loanActive,
  },
  {
    path: "/loan/request",
    name: "Advance Requests ",
    component: loanRequests,
  },

  {
    path: "/loan/overdue",
    name: "Overdue Advance",
    component: loanOverdue,
  },
  {
    path: "/loan/settled",
    name: "Settled Advance",
    component: loanSettled,
  },
  {
    path: "/loan/view/:id",
    name: "Salary Advance Detail",
    component: loanView,
  },
  {
    path: "/payment/received",
    name: "Received Payment",
    component: paymentReceived,
  },

  {
    path: "/baas/topups",
    name: "Baas Top-up",
    component: baasTopUps,
  },
  {
    path: "/baas/account",
    name: "Baas Accounts",
    component: baasAccount,
  },

  {
    path: "/admin/baas/withdrawal/request",
    name: "Withdraw Request",
    component: baasAccountWithdrawal,
  },

  { path: "/payment/refund", name: "Refund Payment", component: paymentRefund },
  {
    path: "/payment/settlement",
    name: "Payment Settlement",
    component: paymentSettlement,
  },
  {
    path: "/customer/approved",
    name: "Approved Customers",
    component: customerList,
  },
  {
    path: "/customer/view/:id",
    name: "Customer Detail",
    component: customerView,
  },
  {
    path: "/customer/new",
    name: "New Customers",
    component: newCustomer,
  },
  {
    path: "/customer/suspended",
    name: "All Suspended",
    component: suspendedCustomer,
  },
  {
    path: "/balances/invoices",
    name: "Orders",
    component: invoices,
  },

  {
    path: "/admin/invoices",
    name: "Invoice",
    component: adminInvoices,
  },
  {
    path: "/admin/settlements",
    name: "Invoice Settlements",
    component: adminInvoiceSettlement,
  },
  {
    path: "/balances/report",
    name: "Report",
    component: report,
  },

  {
    path: "/message/inbox",
    name: "Inbox",
    component: messageInbox,
  },

  {
    path: "/message/outbox",
    name: "Outbox",
    component: messageOutbox,
  },
  {
    path: "/message/baas",
    name: "Baas Messages",
    component: messageBaasOutbox,
  },
  {
    path: "/provider/management",
    name: "Provider Mangement",
    component: orgProviderAccount,
  },
  {
    path: "/settings/preference",
    name: "Preferences",
    component: orgAccountPreference,
  },
  {
    path: "/goals/active",
    name: "Active Goal",
    component: goalActive,
  },
  {
    path: "/goals/overdue",
    name: "Overdue Goal",
    component: goalOverdue,
  },
  {
    path: "/goals/inactive",
    name: "Inactive Goal",
    component: goalInActive,
  },
  {
    path: "/goals/complete",
    name: "Complete Goal",
    component: goalCompleteActive,
  },
  {
    path: "/corporate/list",
    name: "All Corporates",
    component: allCorporates,
  },
  {
    path: "/corporate/add",
    name: "Add Corporate",
    component: addCorporate,
  },
  {
    path: "/corporate/view/:id",
    name: "Corporate Detail",
    component: corporateView,
  },
  {
    path: "/partner/dashboard",
    name: "Dashboard",
    component: dashboardPartner,
  },
  {
    path: "/partner/client/list",
    name: "Client List",
    component: employeeList,
  },
  {
    path: "/partner/blocked/client/list",
    name: "Blocked Client List",
    component: clientBlocked,
  },

  {
    path: "/client/add",
    name: "New Client",
    component: newClient,
  },
  {
    path: "/partner/loan/request",
    name: "Loan Requests",
    component: loanRequestPartner,
  },
  {
    path: "/partner/loan/unpaid",
    name: "Late Loan",
    component: loanUpaidPartner,
  },
  {
    path: "/partner/loan/disbursed",
    name: "Late Loan",
    component: loanActivePartner,
  },
  {
    path: "/partner/issue/loan/:id",
    name: "Issue Loan",
    component: loanIssueFrom,
  },
  {
    path: "/partner/loan/paidup",
    name: "Paid Up Loan",
    component: loanPaidUpPartner,
  },

  {
    path: "/partner/invoices",
    name: "Invoices",
    component: invoicePartner,
  },
  {
    path: "/partner/settlement",
    name: "Invoice Settlement",
    component: invoiceSettlement,
  },
  {
    path: "/baas/received",
    name: "Received Payment",
    component: baasPaymentRecieved,
  },
  {
    path: "/baas/refund",
    name: "Refund Payment",
    component: baasPaymentRefund,
  },
  {
    path: "/baas/initiated/withdrawal",
    name: "Initiated Withdrawal",
    component: baasWithdrawal,
  },
  {
    path: "/baas/initiated/transfer",
    name: "Initiated Tranafer",
    component: baasIntiatedTransfer,
  },

  {
    path: "/baas/disbursement",
    name: "Payment Settlement",
    component: baasDisbursement,
  },
  {
    path: "/partner/topup",
    name: "Account Summary",
    component: topUp,
  },
  {
    path: "/partner/account/statement",
    name: "Account Statement",
    component: baasAccountStatement,
  },
  {
    path: "/card/payment",
    name: "Payment Method",
    component: orgProviderPaymentMethod,
  },
  {
    path: "/payment/status",
    name: "Payment Status",
    component: orgConfirmationStatus,
  },
  {
    path: "/user/list",
    name: "System users",
    component: users,
  },
  {
    path: "/user/roles",
    name: "System Roles",
    component: roles,
  },
  {
    path: "/user/permission",
    name: "System Permission",
    component: permission,
  },
  {
    path: "/user/add",
    name: "Create User",
    component: addUser,
  },
  {
    path: "/user/edit/:id",
    name: "Edit User",
    component: editUser,
  },

  {
    path: "/corporate/account/user",
    name: "Account Users",
    component: corporateUsers,
  },
  {
    path: "/corporate/manager/list",
    name: "Account Managers",
    component: accountManger,
  },
  {
    path: "/corporate/manager/:id",
    name: "View Account Manager",
    component: accountMangerView,
  },
  {
    path: "/report/revenue/list",
    name: "View Revenue",
    component: wageIncomeRecieved,
  },
  {
    path: "/report/aging/analysis",
    name: "Ageing Report",
    component: WageAgeingReport,
  },
];
export default routes;
